"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.text = exports.style = exports["default"] = void 0;
var promoIdentifierConfig = {
  text: {
    size: {
      xxs: 'm2',
      m: 'm1',
      l: '1'
    }
  },
  style: {
    backgroundColor: {
      black: 'var(--color-global-black)',
      brand: 'var(--color-brand-mid)',
      featured: 'var(--color-functional-panelDark)'
    },
    textColor: {
      black: 'var(--color-base-white)',
      brand: 'var(--color-base-white)',
      featured: 'var(--color-global-grey900)'
    }
  }
};
var text = exports.text = promoIdentifierConfig.text,
  style = exports.style = promoIdentifierConfig.style;
var _default = exports["default"] = promoIdentifierConfig;